import { render, staticRenderFns } from "./TalentRecommend.vue?vue&type=template&id=838333ec&scoped=true&"
import script from "./TalentRecommend.vue?vue&type=script&lang=js&"
export * from "./TalentRecommend.vue?vue&type=script&lang=js&"
import style0 from "./TalentRecommend.vue?vue&type=style&index=0&id=838333ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_prettier@3.0.3_vue-template-compiler@2.6.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838333ec",
  null
  
)

export default component.exports